// extracted by mini-css-extract-plugin
module.exports = {"footer":"CheckoutViewFrame-ZenViewGridLess-footer-73bdeb0c"};